@if (loading) {
  <div class="dialog-loader">
    <sem-loader [showLoader]="true"></sem-loader>
  </div>
}

<div class="linked-data-dialog">

  <div class="close" (click)="closeDialog()"></div>

  <div class="right-sub-section-holder">
    <div class="icon-link-data"></div>
    <p>
      {{linkWithExistingData}}
    </p>
  </div>

  <div class="tree-search-wrapper">
    <label class="tree-search-label">{{translationsService.translate('galis_js_dashboard_search')}}</label>
    <input type="text" class="tree-search-input" [(ngModel)]="searchTerm" (ngModelChange)="onSearchChanged()" (keyup.enter)="onEnter()" />
    <!--<div class="SemTextBoxControl" ><div class="form-group"><label>{{translationsService.translate('galis_js_dashboard_search')}}</label><sem-text-box [parentBindingProp]="''" [predefinedValueEvent]="''" [showTooltipValue]="false" [isNumberInput]="false" [isReadOnly]="false" [model]="model" [attr.disabled]="true" tabName="" [form]="f" [ngModel]="searchTerm" name="searchTerm" ></sem-text-box></div></div>-->
  </div>


  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="sem-tree">
    <ng-scrollbar [visibility]="'hover'">
      <!-- This is the tree node template for leaf nodes -->
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
        <li class="mat-tree-node">
          <!-- use a disabled button to provide padding for tree leaf -->
          <button mat-button disabled></button>
          <a (click)="linkClicked(node)" [class.tree-node-not-selectable]="!node.selectable" [attr.title]="node.selectable ? null : notSelectableHint">{{node.name}}</a>
        </li>
      </mat-tree-node>
      <!-- This is the tree node template for expandable nodes -->
      <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
        <li>
          <div class="mat-tree-node">
            <button mat-flat-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
              <mat-icon class="mat-icon-rtl-mirror">
                {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
              </mat-icon>
            </button>
            <a (click)="linkClicked(node)" [class.tree-node-not-selectable]="!node.selectable" [attr.title]="node.selectable ? null : notSelectableHint">{{node.name}}</a>
          </div>
          <ul [class.sem-tree-invisible]="!treeControl.isExpanded(node)">
            <ng-container matTreeNodeOutlet></ng-container>
          </ul>
        </li>
      </mat-nested-tree-node>
    </ng-scrollbar>
  </mat-tree>


</div>